/** @format */

import {ContinueOrderFromQuote} from './continue_order_from_quote';
import {EmailQuoteModal} from './email_quote_modal';
import {DuplicateOrder} from './duplicate_order';
import {ArchiveQuote} from './archive_quote';
import {AddToCart} from './add_to_cart';
import React from 'react';

export const ActionColumn = props => {
    const {order} = props;
    return (
        <div className="saved-orders-list-table-active-00fb__column--action">
            <div>
                <ContinueOrderFromQuote order={order} />
                <AddToCart order={order} />
                <EmailQuoteModal order={order} />
                <DuplicateOrder order={order} />
                <ArchiveQuote order={order} />
            </div>
        </div>
    );
};
